var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: {
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "myModalLabel"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-scrollable modal-xl",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "modal-header d-flex justify-content-between align-items-start"
              },
              [
                _c("div", [
                  _c("h5", { staticClass: "mb-0" }, [
                    _vm._v(
                      _vm._s(_vm.$t("txtDutyName")) +
                        " - " +
                        _vm._s(this.duty.title)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-right" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("txtStartDate")) +
                        ": " +
                        _vm._s(_vm.formatDateTime(_vm.activity.startDate)) +
                        " \n\t\t\t\t\t\t\t"
                    ),
                    _c("span", { staticClass: "mx-1" }, [_vm._v("|")]),
                    _vm._v(
                      " \n                " +
                        _vm._s(
                          Math.floor(
                            (Date.now() - _vm.activity.startDate) /
                              (1000 * 60 * 60 * 24)
                          )
                        ) +
                        " " +
                        _vm._s(_vm.$t("generalDays")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "mx-1" })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "badge badge-primary p-2" }, [
                    _c("i", { staticClass: "fas fa-user-edit mr-1" }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("txtLastUpdate")) +
                        ": \n\t\t\t\t\t\t\t"
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.activity.username))]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.formatDateTime(_vm.activity.currentDate)) +
                          ")"
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "btn-group w-100 mb-2" },
                [
                  _c(
                    "TabButton",
                    {
                      attrs: { tab: "info" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-file-signature" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("txtDutyBasic")) + "\n\t\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "TabButton",
                    {
                      attrs: { tab: "tasks" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-tasks" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("txtTaskInfo")) + "\n\t\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "TabButton",
                    {
                      attrs: { tab: "cell" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-box" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("generalInfo")) +
                          " - " +
                          _vm._s(_vm.$t("activityCellName")) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "info",
                      expression: "tab === 'info'"
                    }
                  ]
                },
                [
                  _c("TabInfo", {
                    attrs: {
                      activity: _vm.activity,
                      availablePriorities: _vm.availablePriorities,
                      availableResponsibles: _vm.availableResponsibles,
                      duty: _vm.duty
                    },
                    on: { change: _vm.notifyChange }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mx-0 mt-2" }, [
                    _c("div", { staticClass: "col-6 px-0" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 px-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary float-right",
                          on: {
                            click: function($event) {
                              _vm.tab = "tasks"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("txtNext")) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "tasks",
                      expression: "tab === 'tasks'"
                    }
                  ]
                },
                [
                  _c("TabTasks", {
                    attrs: {
                      activity: _vm.activity,
                      duty: _vm.duty,
                      cells: _vm.cells,
                      disabled: _vm.isActivityDisableDetails
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mx-0 mt-2" }, [
                    _c("div", { staticClass: "col-6 px-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          on: {
                            click: function($event) {
                              _vm.tab = "info"
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("txtPrev")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 px-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary float-right",
                          attrs: { disabled: !_vm.canComplete },
                          on: { click: _vm.onComplete }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("txtFinish")) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "cell",
                      expression: "tab === 'cell'"
                    }
                  ]
                },
                [
                  !_vm.isActivityDisableDetails
                    ? _c("TabCell", {
                        attrs: {
                          activity: _vm.activity,
                          cell: _vm.cell,
                          line: _vm.line
                        }
                      })
                    : _c("div", { staticClass: "error-container" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("errorIllegalAccess")) +
                            "\n            "
                        )
                      ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary px-4",
                  attrs: { type: "button", "data-dismiss": "modal" }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("btnCancel")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary px-4 shadow-sm",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    title: _vm.$t("activityModal.save")
                  },
                  on: { click: _vm.save }
                },
                [
                  _c("i", { staticClass: "fas fa-save mr-1" }),
                  _vm._v(" " + _vm._s(_vm.$t("btnSave")) + "\n    \t\t\t")
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }